import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9fa68fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "help-text text-size-12"
}

import { computed } from "vue";
import TextFieldWithIconGroup from "@/components/molecules/form/TextFieldWithIconGroup.vue";
import ValidationProvider from "@/components/organisms/validation/ValidationProvider.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInputGroup',
  props: {
  modelValue: {
    type: String,
    default: ""
  },
  name: {
    type: String,
    default: "パスワード"
  },
  label: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: "パスワード"
  },
  hideHelpText: {
    type: Boolean,
    default: false
  },
  strict: {
    type: Boolean,
    default: undefined
  },
  requiredOnly: {
    type: Boolean,
    default: false
  },
  vid: {
    type: String,
    default: "password"
  },
  helpText: {
    type: String,
    default: "半角英数字を組み合わせて8文字以上で設定してください"
  }
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props;





const inputValue = computed({
  get: (): string => props.modelValue,
  set: (value: string) => emit("input", value)
});
const rules = computed((): string => {
  if (props.requiredOnly) {
    return "required";
  }
  let rule = "required|min:8|max:500";
  if (props.strict) {
    rule += "|include_hankaku_english|include_hankaku_number";
  }
  return rule;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ValidationProvider, {
    vid: __props.vid,
    name: __props.name,
    rules: rules.value,
    tag: "div"
  }, {
    default: _withCtx(({ errors, meta, handleChange }) => [
      _createVNode(TextFieldWithIconGroup, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        label: __props.label,
        type: "password",
        "validation-state": { errors, valid: meta.valid },
        showPasswordToggle: "",
        onInput: value => handleChange(value),
        class: "sentry-mask glay-password"
      }, null, 8, ["modelValue", "label", "validation-state", "onInput"]),
      _createTextVNode(),
      (!__props.hideHelpText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.helpText), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["vid", "name", "rules"]))
}
}

})